"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  layout: {
    title: 'Завершить регистрацию на LEVEL.TRAVEL'
  },
  confirm_email: {
    link: '/'
  },
  partner: {
    isWl: true,
    name: 'TinkoFF',
    logo: 'https://s3.yc.level.travel/partner_logos/partner/973/9.png',
    link: 'https://tinkoff.level.travel'
  },
  webmail: {
    link: '/'
  }
};